var TvAuthService = (function () {
    function TvAuthService() {
        var _this = this;
        this.setPassword = function (msisdn, password, otp, successCallback, errorCallback, domain) {
            var data = { password: password, msisdn: msisdn, otp: otp, domain: domain };
            fetch('/rest/set-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
            }).then(function (response) {
                if (response.status === 200) {
                    successCallback();
                    return;
                }
                response.json().then(function (data) {
                    errorCallback(data);
                });
                errorCallback('');
            });
        };
        this.setMsisdn = function (msisdn, motp, tvSubscriberId, successCallback, errorCallback) {
            var data = { newMsisdn: msisdn, tvSubscriptionId: tvSubscriberId, motp: motp };
            fetch('/rest/set-msisdn', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
            }).then(function (response) {
                if (response.status === 200) {
                    successCallback();
                    return;
                }
                response.json().then(function (data) {
                    errorCallback(data);
                });
                errorCallback('');
            });
        };
        this.formatUsername = function (msisdn) {
            return _this.insertToken(msisdn, ' ', [3, 6, 8]);
        };
        this.formatOtp = function (smsCode) {
            return _this.insertToken(smsCode, '-', [3]);
        };
        this.insertToken = function (originalString, token, tokenPositions) {
            if (!originalString)
                return '';
            var withoutToken = originalString.split(token).join('');
            var withTokens = '';
            for (var i = 0; i < withoutToken.length; i++) {
                if (tokenPositions.includes(i)) {
                    withTokens += token;
                }
                withTokens += withoutToken[i];
            }
            return withTokens;
        };
        this.removeSpaces = function (username) {
            if (!username) {
                return '';
            }
            return username.replace(/\s+/g, '');
        };
    }
    return TvAuthService;
}());
export var tvAuthService = new TvAuthService();
